export default "__VITE_ASSET__DgntkwD3__"